/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Soft_SkillsInputs */

const en_job_form_soft_skills = /** @type {(inputs: Job_Form_Soft_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft Skills`)
};

const de_job_form_soft_skills = /** @type {(inputs: Job_Form_Soft_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft Skills`)
};

/**
* | output |
* | --- |
* | "Soft Skills" |
*
* @param {Job_Form_Soft_SkillsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_soft_skills = /** @type {((inputs?: Job_Form_Soft_SkillsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Soft_SkillsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_soft_skills(inputs)
	return en_job_form_soft_skills(inputs)
});